import NetworkUtil from "./NetworkUtil";

export class CustomerAPI{
    public static async getPolicyName():Promise<{success:boolean, name:string}> {
        return NetworkUtil.makeGet("/api/system/legalName")
    }

}